import { Brand } from "effect";
import { Schema } from "@effect/schema";

export const PERCENT_DECIMALS = 18;
export const PERCENT_FACTOR = 10n ** BigInt(PERCENT_DECIMALS);

type PercentBrand = bigint & Brand.Brand<"Percent">;
const PercentBrand = Brand.nominal<PercentBrand>();

export type Percent = typeof Percent.Type;
export type PercentEncoded = typeof Percent.Encoded;

export const Percent = Schema.BigInt.pipe(
  Schema.fromBrand(PercentBrand)
).annotations({ identifier: "Percent" });

export const PercentFromSelf = Schema.typeSchema(Percent);

export const PercentFromBigInt = Schema.BigIntFromSelf.pipe(
  Schema.fromBrand(PercentBrand)
).annotations({ identifier: "PercentFromBigInt" });

export const PERCENT_ZERO = makePercent(0n);
export const PERCENT_ONE_HUNDRED = makePercent(PERCENT_FACTOR);

export function makePercent(value: bigint): Percent {
  return Percent.make(value);
}
